<template>
  <div class="ui basic segment" id="gdpr-banner" v-if="!userHasAccepted">
    <div class="ui large floating message">
      <i class="close icon" @click="close"></i>
      <span>By using our services you agree to BizLibrary's <a href="https://www.bizlibrary.com/legal/cookie-policy/" target="_blank">Cookie Policy</a> and <a href="https://www.bizlibrary.com/legal/privacy-commitment/" target="_blank">Privacy Statement</a>.</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'GDPRBanner',
  data() {
    return {
      userHasAccepted: false,
    };
  },
  methods: {
    close() {
      localStorage.setItem(
        'GDPR-accepted',
        true,
      );
      this.userHasAccepted = true;
    },
  },
  mounted() {
    this.userHasAccepted = localStorage.getItem('GDPR-accepted');
  },
};
</script>

<style lang="less" scoped>
  #gdpr-banner {
    width: 50%;
    .ui.message {
      text-align: center;
    }
  }
</style>
